import { AlertCircle } from "lucide-react";

import { Card, CardContent } from "../../ui";

export interface ErrorMessageProps {
  title?: string;
  description?: string;
}

export const ErrorMessage = ({ title, description }: ErrorMessageProps) => (
  <div className="h-full flex items-center justify-center">
    <Card className="w-full max-w-md mx-4">
      <CardContent className="pt-6">
        <div className="flex mb-4 gap-2">
          <AlertCircle className="h-8 w-8 text-red-500" />
          <h1 className="text-2xl font-bold text-gray-900">{title ?? "Произошла ошибка"}</h1>
        </div>

        <p className="mt-4 text-sm text-gray-600">
          {description ?? "Пожалуйста, попробуйте снова позже"}
        </p>
      </CardContent>
    </Card>
  </div>
);
